var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFacebookIconV2(_ref, svgRef) {
  var {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.9731 12.0733C24.9731 5.40541 19.5677 0 12.8998 0C6.23183 0 0.826416 5.40541 0.826416 12.0733C0.826416 18.0994 5.24144 23.0943 11.0133 24V15.5633H7.9478V12.0733H11.0133V9.41343C11.0133 6.38755 12.8158 4.71615 15.5736 4.71615C16.8941 4.71615 18.2762 4.95195 18.2762 4.95195V7.92313H16.7538C15.2541 7.92313 14.7862 8.85386 14.7862 9.80959V12.0733H18.1347L17.5994 15.5633H14.7862V24C20.5581 23.0943 24.9731 18.0994 24.9731 12.0733Z",
    fill: "#1877F2"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebookIconV2);
export default __webpack_public_path__ + "static/media/FacebookIconV2.65b80587844d89aae06dbbed2126fc92.svg";
export { ForwardRef as ReactComponent };